import { Icon } from '@zenchef/ds-react'
import { Text } from '@zenchef/ui'
import { Box } from 'rebass'
import { withTheme } from 'styled-components'
import { height, width } from 'styled-system'

// ADAPTED FROM ZENCHEFUI

const Checkbox = withTheme((props) => {
  const { onChange, id, ...rest } = props
  return (
    <Box
      {...rest}
      css={[
        `
        margin: -1px 0 0 0;
        display: inline-block;
        transition: box-shadow .1s;
        `,
        width,
        height
      ]}>
      <Text {...rest} onChange={onChange} as='input' type='checkbox' css={[`display:none;`]} id={id} />
      <Icon
        {...rest}
        cursor='pointer'
        name={props.checked ? 'check-01' : 'placeholder-square'}
        fontSize='14px'
        borderRadius='2px'
        verticalAlign='middle'
        bg={props.checked ? 'background.brand.adaptive' : 'white'}
        color={props.checked ? 'white' : props.error ? 'red.500' : 'charcoal.200'}
        boxShadow={props.checked ? '0 1px 2px rgba({colors.restaurant.rgb},0.5)' : 'none'}
      />
    </Box>
  )
})

export default Checkbox
